import React from 'react'
import VerticalAlignTopIcon from '@material-ui/icons/VerticalAlignTop'
import VerticalAlignCenterIcon from '@material-ui/icons/VerticalAlignCenter'
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom'
import ButtonSelectOption from './ButtonSelectOption'

export interface ColumnAlignmentOptionProps {
  value: string
  onChange: (value: 'top' | 'center' | 'bottom') => void
}

/**
 * The `columnAlign` control shared by the real `2-column` block (`TwoColumnOptions`) and the global
 * footer (`FooterInspectorPanel`) — both lay out two columns and expose the same vertical-alignment
 * vocabulary for them, so the control lives once rather than being hand-copied per caller.
 */
export default function ColumnAlignmentOption(props: ColumnAlignmentOptionProps) {
  const { value, onChange } = props

  return (
    <ButtonSelectOption
      label={'Column Alignment'}
      value={value}
      buttons={[
        { icon: <VerticalAlignTopIcon />, value: 'top' },
        { icon: <VerticalAlignCenterIcon />, value: 'center' },
        { icon: <VerticalAlignBottomIcon />, value: 'bottom' }
      ]}
      onChange={onChange}
    />
  )
}
